<h4 mat-dialog-title *ngIf="modalData" style="margin: 0; padding-left: 50px;">{{ modalData.title }}</h4>

<!-- {{modalData|json}} -->

<mat-dialog-content *ngIf="modalData" class="previewContent">
  <h2 class="mt-3">{{ modalData.newsForm.newsTital }}</h2>

  <div class="row justify-content-between">
    <div class="col-4">
      <p>จำนวนการอ่าน 0 ครั้ง</p>
    </div>
    <div class="col-4">
      <p *ngIf="modalData.newsForm.newsAlwaysOpen == 'true'"
        [class.d-none]="modalData.newsForm.newsAlwaysOpen == 'false'" class="text-right">
        วันที่ {{ dateAlwaysOpen | date }}
      </p>
      <p *ngIf="modalData.newsForm.newsAlwaysOpen == 'false'"
        [class.d-none]="modalData.newsForm.newsAlwaysOpen == 'true'" class="text-right">
        วันที่ {{ modalData.newsForm.newsDate[0] | date }}
      </p>
    </div>
  </div>

  <img [src]="modalData.newsHeader" style="width: 100%;">

  <div class="row">
    <div class="col-12">
      <div class="mt-4" id="_content" [innerHtml]="modalDataDetails"></div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button *ngIf="!modalData.isEdit&&modalData.newsId" mat-button class="lifedi-btn-success" (click)="dulplicateNews()">
    Dulplicate ข่าว
  </button>
  <button *ngIf="!modalData.isEdit&&!modalData.newsId" mat-button class="lifedi-btn-success" (click)="createNews()">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="modalData.isEdit" mat-button class="lifedi-btn-success" (click)="editNews()">
    บันทึก
  </button>
  <button mat-button [mat-dialog-close]="true">
    {{ modalData.cancleBtnText }}
  </button>
</mat-dialog-actions>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>
